<script lang="ts" setup>
defineEmits<{ (e: 'click'): void }>();
</script>

<template>
    <div class="divider-action">
        <div class="divider-action__line" />
        <span class="divider-action__label" @click="$emit('click')">
            <slot />
        </span>
    </div>
</template>

<style lang="scss" scoped>
@use "certifid-v2-client-hub-styles" as *;

.divider-action {
    display: flex;
    align-items: center;
    gap: 1rem;

    &__line {
        flex: 1;
        height: 1px;
        background-color: $dark-gray;
    }

    &__label {
        white-space: nowrap;
        font-size: 0.9rem;
        color: $theme-primary;
        cursor: pointer;

        &:hover {
            color: $black-med;
        }
    }
}
</style>
